import { NavLink } from 'react-router-dom';

import { Separator } from '@swyftx/aviary/atoms/Seperator/Seperator';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { MenuItem } from '@swyftx/aviary/molecules/Menu';

import { useAppSideBar } from '@global-components/Navigation/useAppSideBar';
import { useAppSideBarAvoEvents } from '@global-components/Navigation/useAppSideBarAvoEvents';

import { Item } from './item';

const Title = ({ title, collapsed }: { title?: string; collapsed?: boolean }) => {
  if (!title) return null;
  return (
    <div className='px-8 pt-8'>
      {collapsed ? (
        <Separator className='my-7 w-28' />
      ) : (
        <Body color='secondary' weight='bold' size='xsmall'>
          {title}
        </Body>
      )}
    </div>
  );
};

export const MenuGroup = ({ items, title, collapsed }: { items: Item[]; title?: string; collapsed?: boolean }) => {
  const { onCloseAppBar } = useAppSideBar();
  const { trackRouteNavigation } = useAppSideBarAvoEvents();

  const onAction = (item: Item) => {
    if (item.action) {
      item.action();
    }
    trackRouteNavigation(item.path);

    // always close the app bar when an item is clicked
    onCloseAppBar();
  };

  return (
    <section className='relative grid min-w-[196px] gap-8'>
      <Title title={title} collapsed={collapsed} />
      {items.map((item) => (
        <NavLink to={item.path} key={item.title}>
          {({ isActive }) => (
            <MenuItem
              selectedStyle='minimal'
              action={() => onAction(item)}
              selected={isActive && !item.action}
              color={!isActive || item.path.startsWith('#') ? 'primary' : 'accent'}
              className={`h-48 p-12 ${isActive ? 'active text-color-text-accent' : ''} ${
                collapsed ? 'w-46 overflow-hidden' : ''
              }`}
              endAdornment={item.endAdornment}
              key={item.title}
              text={collapsed ? '' : item.title}
              icon={<div className={isActive ? 'text-color-text-accent' : 'text-color-text-primary'}>{item.icon}</div>}
            />
          )}
        </NavLink>
      ))}
    </section>
  );
};
